export const config = {
  BASE_API_URL: "https://calculator-backend.cdntest.info",
};
